import { HelperManager, helperManager } from '../utils/Helper';
import { blockManager } from './blocks';
import { overlayManager } from './overlay';
class ShareManager {
    shareoverlayTitleText;
    shareoverlaySubtitleText;
    initText($object) {
        this.shareoverlayTitleText = $object.data('shareoverlay-title-text') || '';
        this.shareoverlaySubtitleText = $object.data('shareoverlay-subtitle-text') || '';
    }
    openShareOverlay(object) {
        if (object == null)
            return;
        const $object = $(object);
        this.initText($object);
        const block = $object.closest('.Block');
        if (block.length) {
            this.shareBlock(block);
            return;
        }
        this.sharePage();
    }
    shareBlock($block = null) {
        const block = blockManager.getBlock($block[0]);
        if (block == null)
            return;
        const url = decodeURI(location.href);
        // var text = this.getTitle(block.element.find('.Block_Title').first());
        // if (!text)
        const text = '';
        const theme = block.getTheme(['Theme-Accent']);
        const $overlay = this.getOverlay(url, text, theme);
        overlayManager.open($overlay, this);
    }
    getTitle($title) {
        return $title.text().replace(/\r?\n|\r/g, ' ').replace(/ +(?= )/g, '').trim();
    }
    sharePage() {
        const url = decodeURI(location.href);
        // var text = this.getTitle($('.Title_Wrapper .H').first());
        // if (!text)
        const text = '';
        const theme = helperManager.getTheme(['Theme-Accent'], $('.Header'));
        const $overlay = this.getOverlay(url, text, theme);
        overlayManager.open($overlay, this);
    }
    getOverlay(url, text, theme = null) {
        let overlay = `
      <div class="Overlay Overlay-Small Overlay-Share js-GridItem_Overlay [theme]">
        <div class="Overlay_ContentWrapper ClearFix-Wrapper">
          <hr class="Line">
          <div class="Toolbar">
            <button class="Btn Btn-Square Btn-Default Btn-TextAccent Overlay_CloseBtn"><i class="RIcon-Cross"></i></button>
          </div>
          <div class="Overlay_Content">
            <div class="Overlay_Content-Centered">
              <h3 class="H H2 Block_Title H-NoMarginTop">
                ${this.shareoverlayTitleText}
                <span class="H_Sub">${this.shareoverlaySubtitleText}</span>
              </h3>
              <p>[text]</p>
              <ul class="List-Clear List-Buttons ShareOptions_List"></ul>
            </div>
          </div>
        </div>
      </div>`;
        overlay = overlay.replace('[text]', HelperManager.htmlEncode(text));
        overlay = overlay.replace('[theme]', theme);
        const $overlay = $(overlay);
        const $list = $overlay.find('.ShareOptions_List');
        const media = [
            'Facebook',
            'X',
            'LinkedIn'
            // 'Whatsapp'
        ];
        for (const medium of media) {
            $list.append(this.getShareOption(medium, url));
        }
        return $overlay;
    }
    getShareOption(media, url) {
        let html = `<li class="ShareOptions_Option">
                  <button class="Btn Btn-Accent Btn-FullWidth Overlay_CloseBtn">
                    <i class="Btn_Icon RIcon-CenterVertical RIcon-Size6 RIcon-[media]"></i><span>[media]</span>
                  </button>
                </li>`;
        html = html.replace(/\[media\]/g, media);
        const $html = $(html);
        $html.find('button').click(() => {
            shareManager.share(media, url);
        });
        return $html;
    }
    share(media, url) {
        if (!media)
            return;
        // const pageUrl = decodeURI(location.href);
        let shareUrl;
        // text = encodeURIComponent(text);
        if (media == 'Facebook') {
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        }
        else if (media == 'X') {
            shareUrl = `https://twitter.com/intent/tweet?url=${url}`;
            // &text=${text}&via=radboudumc`;
        }
        else if (media == 'LinkedIn') {
            shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
            // &text=${text}`;
        }
        else if (media == 'Whatsapp') {
            shareUrl = `whatsapp://send?text=${url}`;
            // ${text} `
        }
        if (shareUrl == null)
            return;
        window.open(shareUrl, 'pop', 'width=600, height=400, scrollbars=no, left=5, top=5');
    }
    onClose = () => undefined;
}
const shareManager = new ShareManager();
window.shareManager = shareManager;
